import React from 'react'
import { v4 as uuidv4 } from 'uuid';

const SingleInterest = (props) =>{
    return (
        <>
            <p className="para-text">{props.element}</p>
        </>
    )
}

function Interests(props) {
    return (
        <>
            <p className="heading-text"> INTERESTS </p>
            <div className="interest list">
                {props.interests.map((element)=>{
                    return <SingleInterest key={uuidv4()} element={element}/>
                })}
            </div>
        </>
    )
}

export default Interests
